export default {
  text: {
    type: 'string',
    required: true,
    maxSize: 65000,
  },
  attachments: {
    type: 'array',
    maxSize: 1,
  },
};
